import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Menu } from 'antd';
import './MenuBar.css'

class MenuBar extends Component {
	render() {
		return (
			<Menu
				mode="horizontal"
				theme="light"
				className='menu'
				style={{ float: 'right', minWidth: 467, display: 'block' }}
				items={[
					{ key: 'index', label: <Link to="/index" style={{ color: '#333333' }}>首页</Link> },
					{ key: 'news', label: <Link to="/news" style={{ color: '#333333' }}>资讯</Link> },
					{ key: 'achievement', label: <Link to="/achievement" style={{ color: '#333333' }}>成果</Link> },
					{ key: 'tool', label: <Link to="/tool" style={{ color: '#333333' }}>工具</Link> },
					{ key: 'team', label: <Link to="/team" style={{ color: '#333333' }}>团队</Link> },
					{ key: 'aboutus', label: <Link to="/aboutus" style={{ color: '#333333' }}>关于我们</Link> },
				]}
			/>
		);
	}
}

export default withRouter(MenuBar)
